import React, { useEffect, useState, useRef, useMemo, useCallback } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useAppDispatch } from '../../../stores/hook';
import { appendUtmParams } from '../../../utils/Url';
import language from '../../../utils/LanguageSettings';
import translations from '../../../text/get-started-translations.json';
import { fetchBlogArticle } from '../../functions/fetchBlogArticle';
import { fetchBlog } from '../../functions/fetchBlog';
import { fetchBlogPlans } from '../../functions/fetchBlogPlans';
import { getSubscriptions } from '../../functions/getSubscriptions';
import { SOURCE_URL } from '../../../config';
import { PackInfo } from '../types';
import Swiper from 'swiper';
import 'swiper/css/bundle';
import { resetHeight } from '../../functions/ResetHeight';
import { getPlansSwiperConfig } from '../../functions/getPlansSwiperConfig';
import RenderSnA from '../../functions/renderSnA';
import SwiperItem from '../GetStarted/Items/SwiperItem';
import { setPackInfo, setSubscribeModalStatus } from '../GetStarted/GetStartedSlice';
import Categories from './RightSection/Categories';
import SlideBarArticles from './RightSection/SlideBarArticles';
import Keywords from './RightSection/Keywords';
import { Plan } from '../types';
import PackModal from '../GetStarted/Modals/PackModal';
import SubscribeModal from '../GetStarted/Modals/SubscribeModal/SubscribeModal';
import Gallery from './Gallery';
import { QRCodeSVG } from 'qrcode.react';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import gfm from 'remark-gfm';
import { getLocalizedData } from '../../functions/getLocalizedData';
import facebookImg from '../../../images/icon/facebook.svg';
import whatsappImg from '../../../images/icon/whatsapp-logo.svg';
import threadsImg from '../../../images/icon/Threads.svg';
import wechatImg from '../../../images/icon/Wechat.svg';
import copyShareImg from '../../../images/icon/Copy Share.svg';
import shareBtnImg from '../../../images/icon/share-btn.svg';
import whatsappWImg from '../../../images/icon/whatsapp-w.svg';
import webWImg from '../../../images/icon/web-w.svg';

const initializeSwiper = () => {
  document.querySelectorAll<HTMLElement>(".swiper-container").forEach((container) => {
    const slideCount = container.querySelectorAll(".swiper-slide").length;
    container.querySelectorAll<HTMLElement>(".swiper-button-next, .swiper-button-prev").forEach(button => button.style.display = '');
    if (slideCount === 1) {
      new Swiper(container as HTMLElement, getPlansSwiperConfig(1, { current: null }));
    } else if (slideCount === 2) {
      new Swiper(container as HTMLElement, getPlansSwiperConfig(2, { current: null }));
      container.querySelectorAll<HTMLElement>(".swiper-button-next, .swiper-button-prev").forEach(button => button.style.display = 'none');
    } else if (slideCount === 3) {
      new Swiper(container as HTMLElement, getPlansSwiperConfig(3, { current: null }));
    } else if (slideCount > 3) {
      new Swiper(container as HTMLElement, getPlansSwiperConfig(slideCount, { current: null }));

    }
  });
};

const Article: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const [articleData, setArticleData] = useState<any>(null);
  const [blogData, setBlogData] = useState<any>(null);
  const [ottPlans, setOTTPlans] = useState<any[]>([]);
  const [stbPlans, setSTBPlans] = useState<any[]>([]);
  const [subsribedSTBCampList, setSubsribedSTBCampList] = useState<any[]>([]);
  const [subsribedOTTCampList, setSubsribedOTTCampList] = useState<any[]>([]);
  const [seo, setSeo] = useState<any>(null);
  const [ga, setGa] = useState<any>(null);
  const swiperRef = useRef<any>(null);
  const dispatch = useAppDispatch();
  const link = window.myAppStrapi && window.myAppStrapi.phpButtonLink ? window.myAppStrapi.phpButtonLink : '';
  const campaignCodes = window.myAppStrapi && window.myAppStrapi.campaignCodeArray ? window.myAppStrapi.campaignCodeArray : {};
  const campaignCodeMap = new Map(Object.entries(campaignCodes));
  const [alert, setAlert] = useState<{ message: string; isError: boolean } | null>(null);
  const cust_type = window.myAppStrapi && window.myAppStrapi.cust_type ? window.myAppStrapi.cust_type : '';
  const pageTranslations = translations[language];

  useEffect(() => {
    console.log("cust_type", cust_type);
    if (cust_type === "ott") {
      getSubscriptions()
        .then(response => {
          if (response.success) {
            if (response.subscriptions) {
              const sourceProductCodes: string[] = [];
              response.subscriptions.forEach((subscription: any) => {
                subscription.assets?.forEach((asset: any) => {
                  if (asset.sourceProductCode && !asset.sourceProductCode.startsWith('FTA')) {
                    sourceProductCodes.push(asset.sourceProductCode);
                  }
                });
              });
              console.log("OTT sourceProductCodes", sourceProductCodes);
              setSubsribedOTTCampList(sourceProductCodes);
            }
          } else {
            console.log('getSubscriptions response error - success is not true.');
          }
        }).catch(error => {
          console.log('getSubscriptions catch error:', error);
        });

    } else if (cust_type === '000' || cust_type === '002' || cust_type === '003' || cust_type === '004' || cust_type === '005') {
      const sub_camp_pack = window.myAppStrapi?.sub_camp_pack || null;
      console.log("sub_camp_pack", sub_camp_pack);
      if (sub_camp_pack?.po) {
        const subscribedSTBCampCode: string[] = [];
        if (!Array.isArray(sub_camp_pack.po)) {
          if (sub_camp_pack.po.campaignCode && !sub_camp_pack.po.campaignCode.startsWith('FTA')) {
            subscribedSTBCampCode.push(sub_camp_pack.po.campaignCode);
          }
        }
        else {
          sub_camp_pack.po.forEach((po: any) => {
            if (po.campaignCode && !po.campaignCode.startsWith('FTA')) {
              subscribedSTBCampCode.push(po.campaignCode);
            }
          });
        }
        setSubsribedSTBCampList(subscribedSTBCampCode);
        console.log("subscribedSTBCampCode", subscribedSTBCampCode);
      }

    }
  }, [cust_type]);

  useEffect(() => {
    const getArticle = async () => {
      if (slug) {
        const article = await fetchBlogArticle(slug, language);
        setArticleData(article?.data[0]);

        if (article?.data[0]?.attributes?.OTTPlans?.data?.length > 0) {
          if (cust_type === "" || cust_type === "ott" || cust_type === "not-logged-in" || cust_type === "not-binded") {
            const ottPlanIds = article.data[0].attributes.OTTPlans.data.map((plan: any) => plan.id);
            const ottData = await fetchBlogPlans(article.data[0].lang, true);
            const blogOTTPlans = ottData?.filter((plan: any) => ottPlanIds?.includes(plan.id));
            console.log("blogOTTPlans", blogOTTPlans);
            setOTTPlans(blogOTTPlans || []);
          }
        } else {
          setOTTPlans([]);
        }

        if (article?.data[0]?.attributes?.STBPlans?.data?.length > 0) {
          if (cust_type === '000' || cust_type === '001' || cust_type === '002' || cust_type === '003' || cust_type === '004' || cust_type === '005' || cust_type === 'r2stb') {
            const stbPlanIds = article.data[0].attributes.STBPlans.data.map((plan: any) => plan.id);
            const stbData = await fetchBlogPlans(article.data[0].lang, false);
            let filterSTBPlans: Plan[] = [];
            let blogSTBPlans = stbData?.filter((plan: any) => stbPlanIds?.includes(plan.id));
            blogSTBPlans.forEach((plan: any) => {
              if (plan.attributes.PriceOptionsSTB && plan.attributes.PriceOptionsSTB.length > 0) {
                const filterPriceOptions = plan.attributes.PriceOptionsSTB.filter(priceOption => {
                  return typeof priceOption.Price === 'number' && priceOption.Price >= 0
                });
                if (filterPriceOptions.length > 0) {
                  plan.attributes.PriceOptions = filterPriceOptions;
                  filterSTBPlans.push(plan);
                }
              }
            })
            console.log("blog filterSTBPlans", filterSTBPlans);
            setSTBPlans(filterSTBPlans || []);
          }
        } else {
          setSTBPlans([]);
        }

        if (article?.data?.[0]?.attributes) {
          const attributes = article.data[0].attributes;

          if (attributes.SEO) {
            if(!attributes.SEO.Title && attributes.Title) {
               article.data[0].attributes.SEO.Title = attributes.Title;
            }
            // If SEO exists but no MetaImage, and FeaturedImage exists
            if (!attributes.SEO.MetaImage && attributes.FeaturedImage?.data?.attributes?.url) {
              article.data[0].attributes.SEO.MetaImage = SOURCE_URL + attributes.FeaturedImage.data.attributes.url;
            }
            // Fallback for MetaDescription
            if (!attributes.SEO.MetaDescription && attributes.LeadIn) {
              article.data[0].attributes.SEO.MetaDescription = attributes.LeadIn;
            }
          } else {
            // If SEO doesn't exist, create it and populate from other fields
            article.data[0].attributes.SEO = {};
            if(attributes.Title) {
               article.data[0].attributes.SEO.Title = attributes.Title;
            }
            if (attributes.FeaturedImage?.data?.attributes?.url) {
              article.data[0].attributes.SEO.MetaImage = SOURCE_URL + attributes.FeaturedImage.data.attributes.url
            }
            if (attributes.LeadIn) {
              article.data[0].attributes.SEO.MetaDescription = attributes.LeadIn;
            }
          }
        }

        setSeo(article?.data[0]?.attributes?.SEO || null);
        setGa(article?.data[0]?.attributes?.GA || null);
      }
    };

    const getBlogData = async () => {
      const blog = await fetchBlog(language);
      if (blog) {
        setBlogData({
          filterPageCategories: blog.data.attributes.FilterPageCategories.Categories,
          filterPageKeywords: blog.data.attributes.FilterPageKeywords,
          latestArticles: blog.data.attributes.Articles
            .filter((article: any) => article.attributes.slug !== slug)
            .sort((a: any, b: any) => new Date(b.attributes.updatedAt).getTime() - new Date(a.attributes.updatedAt).getTime())
            .slice(0, 10),
        });
      }
    };

    getArticle();
    getBlogData();

    if (slug) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [slug]);

  useEffect(() => {
    if (ottPlans.length + stbPlans.length > 0) {
      initializeSwiper();
      resetHeight();
    }
  }, [ottPlans, stbPlans]);

  const swiperConfig = useMemo(() => getPlansSwiperConfig(ottPlans.length + stbPlans.length, swiperRef), [ottPlans, stbPlans]);

  const isCampaignSubscribed = useCallback((priceOptions: any[], subscribedList: string[]) => {
    if (!priceOptions || !subscribedList) return false;
    return priceOptions.some(option =>
      option.Campaign && subscribedList.includes(option.Campaign)
    );
  }, []);

  const hasSubscribedPlans = useMemo(() => {
    if (!articleData) return false;

    const isStbUser = ['000', '001', '002', '003', '004', '005', 'r2stb'].includes(cust_type);
    const isOttUser = ["", "ott", "not-logged-in", "not-binded"].includes(cust_type);

    const ottSubscribed = isOttUser && articleData.attributes.OTTPlans.data.some((plan: any) => {
      const ottPlanData = ottPlans.find((p: any) => p.id === plan.id);
      return ottPlanData && isCampaignSubscribed(ottPlanData.attributes.PriceOptions, subsribedOTTCampList);
    });
    const stbSubscribed = isStbUser && articleData.attributes.STBPlans.data.some((plan: any) => {
      const stbPlanData = stbPlans.find((p: any) => p.id === plan.id);
      return stbPlanData && isCampaignSubscribed(stbPlanData.attributes.PriceOptions, subsribedSTBCampList);
    });
    return ottSubscribed || stbSubscribed;
  }, [articleData, ottPlans, stbPlans, subsribedOTTCampList, subsribedSTBCampList, cust_type, isCampaignSubscribed]);

  const onButtonClick = (e: React.MouseEvent<HTMLButtonElement>, packInfo: PackInfo, ott: boolean) => {
    if (packInfo.PriceOptions.length > 1) {
      dispatch(setSubscribeModalStatus(true));
      // store the price when click
      //dispatch(setPackInfo(packInfo));
      const packInfoForModal: any = { ...packInfo, isFromArticle: true, isOTT: ott };
      dispatch(setPackInfo(packInfoForModal));
    } else if (packInfo.PriceOptions && packInfo.PriceOptions.length === 1) {
      //User Type 3(001), 5(004), 7(000, 002), 9(r2stb) Click "subscribe" direct to enquiry page 
      if (cust_type === '000' || cust_type === '001' || cust_type === '002' || cust_type == '004' || cust_type === 'r2stb') {
        window.location.href = '/subscriber-enquiry';
      } else {
       if (!ott) {
         if (packInfo.PriceOptions[0].Campaign) {
           if (campaignCodeMap.size > 0) {
             const cpm = campaignCodeMap.get(packInfo.PriceOptions[0].Campaign);
             const d = new Date();
             d.setTime(d.getTime() + (30 * 24 * 60 * 60 * 1000));
             const expires = "expires=" + d.toUTCString();
             document.cookie = "cpm=" + cpm + ";" + expires + ";path=/";
             window.location.href = link + '&lang=' + articleData.lang;
           }
         }
       } else {
         if (packInfo.PriceOptions[0].Campaign) {
           const url = 'https://ssp.nowtv.now.com/choose-plan?campaign=' + packInfo.PriceOptions[0].Campaign + '&lang=' + articleData.lang;
           window.location.href = appendUtmParams(url)
         }
       }
      }
    }
  }

  const isRecentArticle = (dateString: string) => {
    const updateDate = new Date(dateString);
    const currentDate = new Date();
    const timeDifference = currentDate.getTime() - updateDate.getTime();
    const dayDifference = timeDifference / (1000 * 3600 * 24);
    return dayDifference <= 10;
  };

  // Get current page URL
  const currentUrl = window.location.href;
  // Get page title or custom share text
  const shareTitle = document.title || 'Now TV Blog';

  const handleShare = (platform: string) => {
    try {
      switch (platform) {
        case 'facebook':
          window.open(
            `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(currentUrl)}`,
            '_blank'
          );
          break;
        case 'whatsapp':
          window.open(
            `https://wa.me/?text=${encodeURIComponent(currentUrl)}`,
            '_blank'
          );
          break;
        case 'threads':
          window.open(
            `https://www.threads.net/intent/post?url=${encodeURIComponent(currentUrl)}&text=${encodeURIComponent(shareTitle)}`, '_blank'
          );
          break;
        default:
          break;
      }
    } catch (err) {
      console.error('window.open() failed: ', err);
    }
  };

  const copyUrlToClipboard = () => {
    try {
      // Modern approach using Clipboard API
      navigator.clipboard.writeText(currentUrl)
        .then(() => {
          // Show success message
          setAlert({ message: pageTranslations.LinkCopied, isError: false });
        })
        .catch((err) => {
          console.error('Failed to copy: ', err);
        });
    } catch (err) {
      // Fallback for browsers that don't support Clipboard API
      const tempInput = document.createElement('input');
      document.body.appendChild(tempInput);
      tempInput.value = currentUrl;
      tempInput.select();

      try {
        document.execCommand('copy');
        setAlert({ message: pageTranslations.LinkCopied, isError: false });
      } catch (err) {
        console.error('Failed to copy: ', err);
      }

      document.body.removeChild(tempInput);
    }

    // Remove the alert message after 1.5 seconds
    setTimeout(() => {
      setAlert(null);
    }, 1500);
  };

  const handleMobileShare = async (e: React.MouseEvent) => {
    e.preventDefault();

    // Check if Web Share API is supported
    if (navigator.share || navigator.canShare) {
      try {
        await navigator.share({
          title: shareTitle,
          url: currentUrl
        });
        console.log('Successfully shared');
      } catch (error) {
        console.log('Error sharing:', error);
      }
    } else {
      console.log('Web Share API not supported');
    }
  };

  const formatDate = (dateString: string) => {
    if (!dateString) {
      return null;
    }
    const date = new Date(dateString);
    if (language === 'en') {
      const monthNames = [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
      ];
      const day = date.getDate();
      const monthIndex = date.getMonth();
      const year = date.getFullYear();
      return `${day} ${monthNames[monthIndex]} ${year}`;
    }
    const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long', day: 'numeric' };
    return date.toLocaleDateString('zh-HK', options);
  };

  return (
    <>
      {articleData && (
        <>
          <RenderSnA seo={seo} ga={ga} />
          <div className="blog-wrapper subpage">
            <div className="container">
              <div className="row">
                <div className="col-lg-8">
                  <div className="heading">
                    <h1>{articleData.attributes.Title}</h1>
                    <small>{pageTranslations.UpdatedOn}{formatDate(articleData.attributes.updatedAt)}</small>
                    <div className="tag-share-wrapper">
                      <div className="tags-wrapper">
                        {isRecentArticle(articleData.attributes.updatedAt) && (
                          <Link key="最新文章_Lastet Update" to={`/blog/filter/最新文章_Lastet Update`}>{pageTranslations.LastetUpdate}</Link>
                        )}
                        {articleData.attributes.Categories?.Categories?.map((category: string) => (
                          <Link key={category} to={`/blog/filter/${category}`}>{getLocalizedData(category, language)}</Link>
                        ))}
                      </div>
                      <div className="share-cta-wrapper d-flex">
                        <button className="btn" onClick={() => handleShare('facebook')}> <img src={facebookImg} alt="" /> </button>
                        <button className="btn" onClick={() => handleShare('whatsapp')}> <img src={whatsappImg} alt="" /> </button>
                        <button className="btn" onClick={() => handleShare('threads')}> <img src={threadsImg} alt="" /> </button>
                        <button className="btn wechat-share-btn"> <img src={wechatImg} alt="" />
                          <div className="popupQR">
                            <h4>{pageTranslations.ShareToWeChat}</h4>
                            <div id="urlIMGQR">
                              <QRCodeSVG
                                value={window.location.href}
                                size={120}
                                bgColor="#ffffff"
                                fgColor="#000000"
                                level="H"
                              />
                            </div>
                          </div>
                        </button>
                        <button className="btn copyurl" onClick={copyUrlToClipboard}> <img src={copyShareImg} alt="" />  </button>
                        <button className="btn mobile-share-post" onClick={handleMobileShare}> <img src={shareBtnImg} alt="" /> </button>
                        {alert && (
                          <div className={`alert ${alert.isError ? 'error' : ''}`}>
                            {alert.message}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="content-wrapper">
                    {articleData.attributes.FeaturedImage?.data?.attributes?.url && (
                      <img src={SOURCE_URL + articleData.attributes.FeaturedImage.data.attributes.url} alt="" />
                    )}
                    <div>
                      <ReactMarkdown remarkPlugins={[gfm]} rehypePlugins={[rehypeRaw]}>{articleData.attributes.Content}</ReactMarkdown>
                    </div>
                  </div>

                  <div className="article-tags mt-5">
                    <label>{pageTranslations.Tags}</label>
                    {articleData.attributes.Hashtags?.map((tag: any) => (
                      <Link key={tag.id} to={`/blog/filter#${tag.Hashtags}`} className="btn">#{tag.Hashtags}</Link>
                    ))}
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="slide-sections-wrapper">
                    {blogData && (
                      <>
                        <Categories categories={blogData.filterPageCategories} />
                        <SlideBarArticles slideBarArticles={blogData.latestArticles} type={"latestArticles"} />
                        <Keywords keywords={blogData.filterPageKeywords} />
                      </>
                    )}
                  </div>
                </div>

                <div className="col-lg-12">


                  <div className="get-started-packs">
                    {hasSubscribedPlans ? (
                      <>
                        <h2>{pageTranslations.UpgradeToWatchMore}</h2>
                        <h4>{pageTranslations.SupremeEntertainmentAwaits}</h4>
                      </>
                    ) : (
                      <h2>{pageTranslations.SubscribeToWatch}</h2>
                    )}
                    {!hasSubscribedPlans && (ottPlans.length + stbPlans.length > 0) && (
                      <div className="pack-row">
                        <div className="swiper-container">
                          <div className="swiper-wrapper">
                            {articleData.attributes.OTTPlans.data.map((plan: any) => {
                              const ottPlanData = ottPlans.find((p: any) => p.id === plan.id);
                              return ottPlanData ? (
                                <div key={plan.id} className="swiper-slide">
                                  <SwiperItem
                                    imgSrc={ottPlanData.attributes.plan_img?.data?.attributes?.url || ''}
                                    title={ottPlanData.attributes.name}
                                    description={ottPlanData.attributes.description}
                                    includes={ottPlanData.attributes.includes}
                                    locale={articleData.lang}
                                    price={ottPlanData.attributes.price}
                                    ott_12Mth_price={ottPlanData.attributes.ott_12Mth_price}
                                    stb_price={ottPlanData.attributes.stb_price}
                                    stb_12Mth_price={ottPlanData.attributes.stb_12Mth_price}
                                    ottPriceDetail={ottPlanData.attributes.ottPriceDetail}
                                    stbPriceDetail={ottPlanData.attributes.stbPriceDetail}
                                    ottCampaign={ottPlanData.attributes.ottCampaign}
                                    stbCampaign={ottPlanData.attributes.stbCampaign}
                                    stb_12M_campaign={ottPlanData.attributes.stb_12M_campaign}
                                    box_detail_id={ottPlanData.attributes.box_detail_id}
                                    PriceOptions={ottPlanData.attributes.PriceOptions}
                                    type={"ott"}
                                    Tagline={ottPlanData.attributes.TaglineOTT}
                                    onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                                      const packInfo = {
                                        name: ottPlanData.attributes.name,
                                        PriceOptions: ottPlanData.attributes.PriceOptions || [],
                                        optionsContext: ottPlanData.attributes.optionsContext
                                      }
                                      onButtonClick(e, packInfo, true);
                                    }}
                                  />
                                </div>
                              ) : null;
                            })}
                            {articleData.attributes.STBPlans.data.map((plan: any) => {
                              const stbPlanData = stbPlans.find((p: any) => p.id === plan.id);
                              return stbPlanData ? (

                                <div key={plan.id} className="swiper-slide">
                                  <SwiperItem
                                    imgSrc={stbPlanData.attributes.plan_img?.data?.attributes?.url || ''}
                                    title={stbPlanData.attributes.name}
                                    description={stbPlanData.attributes.description}
                                    includes={stbPlanData.attributes.includes}
                                    locale={articleData.lang}
                                    price={stbPlanData.attributes.price}
                                    ott_12Mth_price={stbPlanData.attributes.ott_12Mth_price}
                                    stb_price={stbPlanData.attributes.stb_price}
                                    stb_12Mth_price={stbPlanData.attributes.stb_12Mth_price}
                                    ottPriceDetail={stbPlanData.attributes.ottPriceDetail}
                                    stbPriceDetail={stbPlanData.attributes.stbPriceDetail}
                                    ottCampaign={stbPlanData.attributes.ottCampaign}
                                    stbCampaign={stbPlanData.attributes.stbCampaign}
                                    stb_12M_campaign={stbPlanData.attributes.stb_12M_campaign}
                                    box_detail_id={stbPlanData.attributes.box_detail_id}
                                    PriceOptions={stbPlanData.attributes.PriceOptions}
                                    type={"stb"}
                                    Tagline={stbPlanData.attributes.TaglineSTB}
                                    onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                                      const packInfo = {
                                        name: stbPlanData.attributes.name,
                                        PriceOptions: stbPlanData.attributes.PriceOptions || [],
                                        optionsContext: stbPlanData.attributes.optionsContext
                                      }
                                      onButtonClick(e, packInfo, false);
                                    }}
                                  />

                                </div>
                              ) : null;
                            })}
                          </div>
                          <div className="swiper-button-next"></div>
                          <div className="swiper-button-prev"></div>
                        </div>
                      </div>
                    )}
                    <div className="more-plans text-center"><a href={(cust_type === "" || cust_type === "ott" || cust_type === "not-logged-in" || cust_type === "not-binded") ? "/get-started" : "/get-started-box"} className="link arrow">{pageTranslations.SeeAllPlans2}</a></div>
                  </div>

                </div>

                {articleData?.attributes?.RelatedBlogArticles?.data?.length > 0 &&
                  <div className="col-lg-12">
                    <div className="more-articles-wrapper">
                      <h4>{pageTranslations.YouMayAlsoLike}</h4>
                      {articleData.attributes.RelatedBlogArticles.data.map((relatedArticle: any) => (
                        <p key={relatedArticle.id}>
                          <Link to={`/blog/${relatedArticle.attributes.slug}`} className="">
                            {relatedArticle.attributes.Title}
                          </Link>
                        </p>
                      ))}
                    </div>
                  </div>
                }
              </div>
            </div>

            <div className="contacts-row-wrapper">
              <div className="container">
                <div className="d-flex justify-content-center">
                  <a href="https://api.whatsapp.com/send?phone=85296133533" target="_blank" className="btn"><img src={whatsappWImg} alt="" /> {pageTranslations.WhatsAppEnquiry}</a>
                  <a href={cust_type === 'r2stb' ? "/subscriber-enquiry" : "https://www.nowtv.now.com/get-started/"} className="btn"><img src={webWImg} alt="" /> {pageTranslations.SubscribeOnline}</a>
                </div>
              </div>
            </div>

            <PackModal />
            <SubscribeModal locale={articleData.lang} />
            <Gallery />

          </div>
        </>
      )}
    </>
  );
};

export default Article;